/* istanbul ignore file */
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useCookiePreferences } from './use-cookie-preferences';
export const AnalyticsContext = createContext({
    sendPageEvent: () => {
        throw new Error('Missing provider');
    },
    sendTrackEvent: () => {
        throw new Error('Missing provider');
    }
});
export const useAnalytics = () => useContext(AnalyticsContext);
export const AnalyticsProvider = ({ children }) => {
    const sendPageEvent = (_name, _payload) => undefined;
    const sendTrackEvent = (_name, _payload) => undefined;
    const { hasOptedOut } = useCookiePreferences();
    const [trackEvents, setTrackEvents] = useState({
        sendPageEvent,
        sendTrackEvent
    });
    useEffect(() => {
        const scriptId = 'atl-global';
        const script = document.createElement('script');
        script.async = true;
        script.src =
            location.hostname === 'trello.com'
                ? 'https://atl-global.atlassian.com/js/atl-global.min.js'
                : 'https://atl-global.stg.atlassian.com/js/atl-global.min.js';
        script.id = scriptId;
        const setWrapperEvents = () => {
            setTrackEvents({
                sendPageEvent: (name, payload) => {
                    var _a;
                    (_a = window.ace) === null || _a === void 0 ? void 0 : _a.analytics.Tracking.pageView(name, payload);
                },
                sendTrackEvent: (name, payload) => {
                    var _a;
                    (_a = window.ace) === null || _a === void 0 ? void 0 : _a.analytics.Tracking.trackEvent(name, payload);
                }
            });
        };
        if (!hasOptedOut) {
            if (!document.getElementById(scriptId)) {
                document.body.appendChild(script);
                script.onload = () => {
                    var _a;
                    (_a = window.ace) === null || _a === void 0 ? void 0 : _a.analytics.Initializer.initAnalytics('trello');
                    setWrapperEvents();
                };
            }
            else {
                setWrapperEvents();
            }
        }
        else {
            setTrackEvents({ sendPageEvent, sendTrackEvent });
        }
    }, [hasOptedOut]);
    return (React.createElement(AnalyticsContext.Provider, { value: Object.assign({}, trackEvents) }, children));
};
//# sourceMappingURL=use-analytics.js.map